import { render, staticRenderFns } from "./privacyPolicy-ar.vue?vue&type=template&id=f4473b9c&scoped=true&"
import script from "./privacyPolicy-ar.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy-ar.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy-ar.vue?vue&type=style&index=0&id=f4473b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4473b9c",
  null
  
)

export default component.exports